const StatisticsRenderer = require('./StatisticsRenderer');
const RenderUtil = require('../RenderUtil');
const LayerUtil = require('../../utils/LayerUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');

/**
 * @typedef G.render.StatisticsRenderMgr~PanelRenderStyle
 * @description 面板展示配置项
 * @type Object
 * @property template {String|Function} 文本模板
 * @property offset {String|Function} 文本模板
 * @property position {String|Function} 文本模板
 */

/**
 * 简文字面板渲染
 * @ignore
 */
let renderer = StatisticsRenderer.extend({
    options: {},
    initialize(options) {
        StatisticsRenderer.prototype.initialize.call(this, options);
        //
        this.featureSet = new g2.sfs.FeatureSet();
        this.layer = new g2.carto.FeatureLayer({});
        this.overlayWare = new g2.widget.OverlayWare({ map: this.options.map });
        this.initListeners();
        //
        this.visible = true;
    },

    /**
     */
    destroy() {
        this.clear();
        StatisticsRenderer.prototype.destroy.call(this);
    },

    getLayer() {
        return this.layer;
    },

    //渲染
    render() {
        let featureSet = this.featureSet;
        let options = this.options.renderOption.style;
        let htmlFn = options.htmlFn;
        if (!htmlFn) {
            htmlFn = (data) => {
                let div = document.createElement("div");
                div.setAttribute('id', [this.options.id, data[this.options.idField]].join('-'));
                let html = `-`;
                div.innerHTML = html;
                return div;
            };
        }
        for (let i = 0; i < featureSet.getCount(); i++) {
            let feature = featureSet.getFeature(i);
            //
            let overlay = new g2.widget.OverLay({
                element: htmlFn(feature._original_data),
                offset: options.offset || [10, 10],
                position: feature.geometry,
                positioning: options.offset || "top-left",
                stopEvent: true
            });
            this.overlayWare.add(overlay);
            //
            feature._overlay = overlay;
        }
    },

    /**
     *
     */
    clear() {
        this.layer.clear();
        this.featureSet.features = [];
        this.overlayWare.clear();
    },

    setVisible(visible) {
        let display = visible ? 'block' : 'none';
        let featureSet = this.featureSet;
        for (let i = 0; i < featureSet.getCount(); i++) {
            let feature = featureSet.getFeature(i);
            let element = feature._overlay.element;
            element.style.display = display;
        }
        this.visible = !!visible;
    },

    getVisible() {
        return this.visible;
    },

    addListeners() {},

    removeListeners() {},

});

module.exports = renderer;